module.exports = __webpack_public_path__ + "img/activity2.5c9ec12b.png";